
import { defineComponent, PropType } from 'vue'
import {
  Ecosystem,
  VulnerabilityOccurrenceFixability,
  VulnerabilityRemediationFixPath,
  VulnerabilityRemediationFixPathUpdate
} from '~/types/types'
import { resolveNodes } from '~/utils/array'
import { getEcosystemName } from '~/utils/dependencies'

export default defineComponent({
  name: 'RemediationModal',
  data() {
    return {
      selectedFixPathId: null as VulnerabilityRemediationFixPath['id'] | null
    }
  },
  props: {
    identifier: {
      type: String,
      required: true
    },
    ecosystem: {
      type: String as PropType<Ecosystem>,
      required: true
    },
    packageName: {
      type: String,
      required: true
    },
    packageVersion: {
      type: String,
      required: true
    },
    fixability: {
      type: String as PropType<VulnerabilityOccurrenceFixability>,
      required: true
    },
    fixedVersions: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    fixPaths: { type: Array as PropType<VulnerabilityRemediationFixPath[]>, default: () => [] },
    loading: {
      type: Boolean,
      default: false
    },
    isCreatingPr: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    VulnerabilityOccurrenceFixability() {
      return VulnerabilityOccurrenceFixability
    }
  },
  methods: {
    getEcosystemName,
    getPackageUpdates(
      fixPath: VulnerabilityRemediationFixPath
    ): VulnerabilityRemediationFixPathUpdate[] {
      if (!fixPath) return []
      return resolveNodes(fixPath.packageUpdates)
    },
    selectFixPath(fixPath: VulnerabilityRemediationFixPath) {
      this.selectedFixPathId = fixPath.id
    }
  }
})
